import '../../index.css';
import styles from './configInfo.module.css';
import { useEffect, useState } from 'react';
import { useSearchParams, createSearchParams, useNavigate } from 'react-router';
import { Errors } from '../../types/errors';
import { failure, unauthorized } from '../../types/api';
import { BoardingModule, ConfigInfoProps, Phase } from '../configLookup/components/Props';
import apiFunctions from '../../api';
import ConfigAccordion from './components/ConfigAccordion';
import BoardingModules from './components/BoardingModules';
import Phases from './components/Phases';
import PhaseInfo from './components/PhaseInfo';
import { CircularProgress } from '@mui/material';
import SubFlows from './components/SubFlows';

const ConfigInfo = () => {
  const [searchParams] = useSearchParams();
  const configid = Number(searchParams.get('id'));

  let [config, setConfig] = useState<ConfigInfoProps | null>(null);
  let [boardingModules, setBoardingModules] = useState<BoardingModule[] | null>(null);
  let [phases, setPhases] = useState<Phase[] | null>(null);
  let [phase, setPhase] = useState<Phase | null>(null);
  let [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let subscribed = true;

    const getConfigDetails = async () => {
      await apiFunctions.apiPost('OnDemand/GetConfigDetails', { OnDemandConfigId: configid }).then((data) => {
        if (data === failure) {
          navigate({
            pathname: '/error',
            search: `?${createSearchParams({ errType: Errors.CallFailed })}`,
          });
        } else if (data === unauthorized) {
          navigate({
            pathname: '/error',
            search: `?${createSearchParams({ errType: Errors.Unauthorized })}`,
          });
        }

        setConfig(data);
        setLoading(false);
      });
    };

    if (loading && subscribed) {
      getConfigDetails();
    }

    return () => {
      subscribed = false;
    };
  }, [configid, loading, navigate]);

  if (loading) {
    return <CircularProgress />;
  }

  if (config == null) return null;

  return (
    <div className={styles.infoWrap}>
      <ConfigAccordion config={config} />

      <div className={styles.boardAndPhase}>
        <SubFlows SubFlows={config.subFlows} setBoardingModules={setBoardingModules} />
        {boardingModules !== null ? (
          <BoardingModules boardingmodules={boardingModules} setPhases={setPhases} setPhase={setPhase} />
        ) : null}
        {phases !== null ? <Phases phases={phases} setPhase={setPhase} /> : null}
        {phase !== null ? <PhaseInfo phase={phase} /> : null}
      </div>
    </div>
  );
};

export default ConfigInfo;
